import { thousandsFormatter } from "../../../utils";
import { ChartPropsWithStringData } from "../models";
import { ChartVariant, formatShareOfTotal } from "../utils";
import { ChartLegendBase } from "./components";

type ChartLegendEmphasis = "Primary" | "Secondary";

interface ChartLegendProps extends ChartPropsWithStringData {
  colours: string[];
  hasData: boolean;
  defaultValue?: string | null;
  showValues?: boolean;
  emphasis?: ChartLegendEmphasis;
  /** Corner radius (px) for the colour swatch — square for Hub, rounded for Seed. */
  keyBorderRadius?: number;
  /** Index of the segment currently being pointed at, from either the legend or the chart. */
  activeIndex?: number | null;
  /** Reports what the legend is being pointed at, so the chart can highlight it. */
  onActiveIndexChange: (index: number | null) => void;
  /** The chart's resolved brand, which beats the provider. */
  variant?: ChartVariant;
}

export const ChartLegendWithSuffix = ({
  data,
  colours,
  hasData,
  defaultValue = null,
  showValues = true,
  emphasis = "Primary",
  keyBorderRadius = 2,
  activeIndex,
  onActiveIndexChange,
  variant,
}: ChartLegendProps): JSX.Element => {
  const total = Object.values(data).reduce((sum, entry) => sum + entry.value, 0);

  return (
    <ChartLegendBase
      labels={Object.keys(data)}
      renderValue={(label) =>
        `${data[label].prefix ?? ""}${thousandsFormatter.format(data[label].value).toLowerCase()} ${data[label].suffix ?? ""}`
      }
      renderPercentage={(label) => formatShareOfTotal(data[label].value, total)}
      colours={colours}
      hasData={hasData}
      defaultValue={defaultValue}
      showValues={showValues}
      emphasis={emphasis}
      keyBorderRadius={keyBorderRadius}
      activeIndex={activeIndex}
      onActiveIndexChange={onActiveIndexChange}
      variant={variant}
    />
  );
};
